import {
    PackageIcon,
    LayoutDashboardIcon,
    ReceiptIcon,
    BanknoteArrowUpIcon,
    CirclePercentIcon,
    UserIcon,
    Building2Icon,
    CircleDollarSignIcon,
    ClockArrowUpIcon,
    Link2Icon,
} from 'lucide-react';
import { ReactElement } from 'react';

type MenuItem = {
    path: string;
    icon: ReactElement;
    label: string;
    featureFlag?: string;
};

const coreNavItems: MenuItem[] = [
    {
        path: '/',
        icon: <LayoutDashboardIcon />,
        label: 'Dashboard',
    },
    {
        path: '/invoices',
        icon: <ReceiptIcon />,
        label: 'Facturas',
    },
    {
        path: '/payments',
        icon: <BanknoteArrowUpIcon />,
        label: 'Pagos',
    },
    {
        path: '/promotions',
        icon: <CirclePercentIcon />,
        label: 'Promociones',
    },
    {
        path: '/users',
        icon: <UserIcon />,
        label: 'Usuarios',
    },
    {
        path: '/companies',
        icon: <Building2Icon />,
        label: 'Compañías',
    },
    {
        path: '/services',
        icon: <PackageIcon />,
        label: 'Servicios',
        featureFlag: 'backoffice.showServicesModule',
    },
    {
        path: '/currency-config',
        icon: <CircleDollarSignIcon />,
        label: 'Tasa de cambio',
    },
];

const quickAccessNavItems: MenuItem[] = [
    {
        path: '/submit-purchase',
        icon: <ClockArrowUpIcon />,
        label: 'Cargar compra',
        featureFlag: 'backoffice.submitPurchaseEnabled',
    },
    {
        path: '/payment-links',
        icon: <Link2Icon />,
        label: 'Links de pago',
    },
];

export { coreNavItems, quickAccessNavItems };
